import CookieService from "@/services/Cookie"
import StorageService from "@/services/Storage"

import authConfig from "@/config/auth"
import ApiService from "@/services/Api"
import { Notification } from "@/components"
import UserService from "@/services/User"
import PushNotificationSubscriberService from "@/services/PushNotificationSubscriber"
import RoleService from "@/services/RoleService"

import ErrorHandlerService from "@/services/ErrorHandler"
import { ErrorType } from "@/hooks/useValidation"
import { deviceIsMobile } from "@/utils/checkDevice"

class AuthService {
	get authTokenKey (): string {
		return authConfig.authTokenKey
	}

	get authToken (): string | null {
		const authToken = CookieService.get(this.authTokenKey) || StorageService.get("account-token") as string

		return authToken
	}

	async isLoggedIn (): Promise<boolean> {
		const isLoggedIn = await UserService.isLoggedIn()

		return isLoggedIn
	}

	async login (callbackHref?: string): Promise<void> {
		try {
			const userInfo = await UserService.getInfo()

			if (!userInfo) window.location.replace("/signin")

			const canAccessManagerPanel = await RoleService.checkPermission("manager-panel", "access")
			const redirectPath = canAccessManagerPanel && !deviceIsMobile() ? "/admin" : "/attendance"

			window.location.replace(callbackHref || redirectPath)
		} catch (error) {
			ErrorHandlerService.handle(error as ErrorType)

			window.location.replace("/signin")
		}
	}

	async logout (windowLocationAfterLogout?: string): Promise<void> {
		try {
			await PushNotificationSubscriberService.unsubscribe()
			await ApiService.delete("/auth/logout")

			StorageService.set(StorageService.reservedKeys.INBOX_INSTANCE_ID, null)

			if (windowLocationAfterLogout) {
				window.location.replace(windowLocationAfterLogout)
			}
		} catch (error) {
			Notification.error({ message: "Algo deu errado e não conseguimos identificar. Entre em contato." })
		}
	}

	async redirectToInstance (targetInstanceId: number, callbackHref?: string): Promise<void> {
		try {
			await ApiService.post("/auth/redirect-to-instance", {
				targetInstanceId
			})
			await this.login(callbackHref)
		} catch (error) {
			ErrorHandlerService.handle(error as ErrorType)

			Notification.warning({
				message: `Houve um erro ao redirecionar para a instância ${targetInstanceId}, por favor contacte o suporte`
			})
		}
	}
}

export default new AuthService()
